import { Autocomplete, TextField } from "@mui/material"
import { useState, useEffect, useMemo } from "react"
import API from "../../services/API";

export default function Product({value, onChange, required, disabled, sx}){

    const [products, setProducts] = useState([]);
    const [titleValue, setTitleValue] = useState(value?.title || '')

    useEffect(() => {

        API.get('/products')
            .then(r => setProducts(Array.isArray(r.data) ? r.data : []))
            .catch(e => console.log(e))

    }, [])

    const handleChange = title => {
        setTitleValue(title)
        let product = products.find(c => c.title === title);
        return onChange(product)
    }

    const productTitles = useMemo(() => {
        let titles = [''];

        products.forEach(c => {
            if(titles.indexOf(c.title) < 0) titles.push(c.title);
        })

        return titles;

    }, [products]);

    return <Autocomplete
        options={productTitles}
        renderInput={params => <TextField 
            {...params}
            label='Produit'
            size='small'
            required={required ? true : false}
        />}
        value={titleValue}
        onChange={(e, v) => handleChange(v)}
        disabled={disabled ? true : false}
        sx={sx || {}}
    />
}